import * as fromQuestions from './questions/mutations';
import * as fromOfferings from './offerings/mutations';
import * as fromContributors from './contributors/mutations';
import * as fromOverlay from './overlay/mutations';
import * as fromEvents from './events/mutations';
import * as fromProjects from './projects/mutations';
import * as fromLayout from './layout/mutations';

export default {
    ...fromQuestions.default,
    ...fromOfferings.default,
    ...fromContributors.default,
    ...fromOverlay.default,
    ...fromEvents.default,
    ...fromProjects.default,
    ...fromLayout.default,
};
